import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Period } from '../../components/Period';
import { useDeviceType } from '@cian/ui-kit';
import { MonthMobileGroup } from '../../components/MonthMobileGroup';
import { MonthGroup } from '../../components/MonthGroup';
import { createStateMonthsAndYears } from './helpers';
import { selectOptions } from '../../../common/selectors/selectOptions';
import { selectIsLoading } from '../../../common/selectors/rating';
import { TThunkDispatch } from '../../../common/types/redux';
import { setCurrentDate } from '../../../common/actions/filters/setCurrentDate';

export const PeriodContainer: React.FC = () => {
  const device = useDeviceType();

  const periods = useSelector(selectOptions);

  const loadingStatus = useSelector(selectIsLoading);

  const yearsSelectOptions = React.useMemo(() => periods.map(({ year }) => ({ label: year, value: year })), [periods]);

  const [monthsAndYears, setMonthsAndYears] = React.useState(createStateMonthsAndYears(periods, yearsSelectOptions));

  React.useEffect(() => {
    setMonthsAndYears(createStateMonthsAndYears(periods, yearsSelectOptions));
  }, [periods, yearsSelectOptions]);

  const dispatch = useDispatch<TThunkDispatch>();

  const changeYear = React.useCallback(
    (value: string) => {
      const newValue = periods.find(period => period.year === value);

      if (newValue) {
        const { months } = newValue;

        const lastMonthValue = months[months.length - 1].value;
        dispatch(setCurrentDate(lastMonthValue));
        setMonthsAndYears({
          monthsThisYear: months,
          year: newValue.year,
          month: lastMonthValue,
        });
      }
    },
    [dispatch, periods],
  );

  const changeMonth = React.useCallback(
    (value: string) => {
      dispatch(setCurrentDate(value));
      setMonthsAndYears(prevState => {
        return { ...prevState, month: value };
      });
    },
    [dispatch],
  );

  const MonthGroupDevice = device === 'phone' ? MonthMobileGroup : MonthGroup;

  return (
    <Period
      monthGroup={
        <MonthGroupDevice
          months={monthsAndYears.monthsThisYear}
          onChangeMonth={changeMonth}
          ratingIsLoading={loadingStatus}
          currentMonth={monthsAndYears.month}
        />
      }
      ratingStatus={loadingStatus}
      yearOptions={yearsSelectOptions}
      handleYear={changeYear}
      currentYear={monthsAndYears.year}
    />
  );
};
